import ProjectOne from '../../assets/p2.png'
import ProjectTwo from '../../assets/project2.png'
import ProjectThree from '../../assets/project3.png'

export const projects = [
  {
    id: 1,
    title: "Zafflo",
    subtitle: "Digital Menu & QR Order Management SaaS",
    category: "SaaS & Web Apps",
    featured: true,
    description: "A comprehensive digital menu and order management SaaS for modern restaurants. Designed to streamline table operations, enable contactless QR ordering, and simplify real-time menu modifications with an integrated billing pipeline.",
    highlights: [
      "Contactless QR-code menu & instant table order routing",
      "Real-time kitchen order dashboard powered by Firebase Cloud Messaging",
      "Integrated Stripe payment gateway & split billing support",
      "Dynamic menu item customization & stock management"
    ],
    metric: "Fast 100ms sync speed",
    tags: ["React", "TypeScript", "Tailwind", "Firebase", "Stripe"],
    imageUrl: ProjectOne,
    projectUrl: "https://zafflo.com/",
    githubUrl: "https://github.com/matin808/zafflo-client"
  },
  {
    id: 2,
    title: "Glasses' N More Admin Panel",
    subtitle: "Enterprise Backoffice & Inventory Dashboard",
    category: "Admin & Enterprise",
    featured: false,
    description: "Enterprise-grade backoffice system for eyewear catalog administration. Implements advanced role-based access control (RBAC), multi-layered filtering, database indexes for speedy catalog search, and sales charts.",
    highlights: [
      "Role-Based Access Control (RBAC) with granular admin permissions",
      "Complex eyewear variant & prescription catalog indexer",
      "Interactive analytics & sales revenue trend charts",
      "Zod schema validation & automated inventory alerts"
    ],
    metric: "Manage 10,000+ SKUs",
    tags: ["Next.js", "Node.js", "Express", "MongoDB", "TypeScript", "Tailwind", "AWS"],
    imageUrl: ProjectTwo,
    projectUrl: "https://glassesnmore-admin.vercel.app/",
    githubUrl: "https://github.com/matin808/glassesnmore-admin"
  },
  {
    id: 3,
    title: "Glasses' N More Storefront",
    subtitle: "High-Performance E-Commerce Eyewear Platform",
    category: "E-Commerce",
    featured: false,
    description: "High-performance e-commerce eyewear store featuring responsive catalogs, secure payment gateway integrations, and customized user checkout flows designed to minimize drop-off rates.",
    highlights: [
      "Responsive & immersive catalog filterable by frame shapes & material",
      "Optimized checkout flow with multi-currency support",
      "Virtual try-on preview assets & prescription upload wizard",
      "Server-side rendered product pages for SEO search ranking"
    ],
    metric: "<1.2s Page Load Time",
    tags: ["Next.js", "Node.js", "Express", "MongoDB", "TypeScript", "Tailwind", "Zod"],
    imageUrl: ProjectThree,
    projectUrl: "https://app-glassesnmore.vercel.app/",
    githubUrl: "https://github.com/matin808/glassesnmore-store"
  }
];